<template>
  <progressive-background :src="image" :placeholder="thumb" no-ratio>
    <div slot="content">
      <v-col id="app">
        <v-app id="inspire">
          <!-- <nav-bar></nav-bar> -->
          <v-content v-if="!isUserLoggedIn">
            <!-- LOGGED OUT CONTAINER -->
            <landing-page :photo-source="attrib" />
          </v-content>
          <!-- END LOGGED OUT CONTAINER -->

          <!-- LOGGED IN CONTAINER ---- DASHBOARD ----- -->
          <v-content
            v-if="isUserLoggedIn && settings && dashboard && user"
            id="remove-pad"
          >
            <dashboard-view
              :dashboard="dashboard"
              :settings="settings"
              :user="user"
              :photo-source="attrib"
            />
          </v-content>
          <v-content
            v-if="isUserLoggedIn && (!settings || !dashboard)"
            :photo-source="attrib"
          >
            <loading-view />
          </v-content>
          <!-- END LOGGED IN CONTAINER ---- DASHBOARD ----- -->
        </v-app>
        <new-content-available-toastr
          v-if="newContentAvailable"
          class="new-content-available-toastr"
          :refreshing-app="refreshingApp"
          @refresh="serviceWorkerSkipWaiting"
        ></new-content-available-toastr>
        <apple-add-to-home-screen-modal
          v-if="showAddToHomeScreenModalForApple"
          class="apple-add-to-home-screen-modal"
          @close="closeAddToHomeScreenModalForApple(false)"
        >
        </apple-add-to-home-screen-modal>
      </v-col>
    </div>
  </progressive-background>
</template>
<script>
// import NavBar from '@/components/NavBar'
import firebase from '@firebase/app'
import '@firebase/auth'
import Unsplash, { toJson } from 'unsplash-js'
import { mapState, mapActions, mapGetters } from 'vuex'
import NewContentAvailableToastr from './components/NewContentAvailableToastr'
import AppleAddToHomeScreenModal from './components/AppleAddToHomeScreenModal'

import LandingPage from './views/LoggedOut/LandingPage'
import LoadingView from './views/LoggedIn/LoadingView'
import DashboardView from './views/LoggedIn/DashboardView'

const unsplash = new Unsplash({
  accessKey: 'wMk6qWd3c7-nfILeBC2qw6PSNWiXh8xzncHp4TAG1B8'
})
// eslint-disable-next-line
const imageList = ['Q30KtoAPzYc','0cCLFe5lLHM','Uq3gTiPlqRo','jKm_7pnYvQ0','xgAcJZRk9_8','CZABLi1Lbk4','_rPzfuPWxMU','ILlmVlkNcHU','He4OH2g7oLE','MhwKMIGknKE','b7MZ6iGIoSI','LmDtHyqCQb0','kjgTs1W3aGU','1E6nZj6FZxA','DyDR8oOzuNA','-V9ivM5Xd_k','lQ5zJ-jYkJI','NAPQMB6gkm8','Ic4GZfiT57c','w5IiPzQj3XI','Iay5RmQZo8Q','cbtae72OiJE','sTlt9jwokYE','8ZAxI5FwjFo','P6NhhvGIL9k','2q5aDZUq2M4','S7mAngnWV1A','ps2daRcXYes','yuiJO6bvHi4','FQxII3eqkJk','8UTyHv3xbr4','EOxpS6yBQU4','-TQUERQGUZ8','fq-VeKf8KnE','X4ykPFa8ibY','HtNaHn5ZsWM','FqaybX9ZiOU','epOFv5uOIgg','KqR6FmcT_N0','AQO1lAaZ2OE','GFk0Q-Dehj4','-9Ap357MJ8s','fRBpWLAcWIY','NQbWpSuOJQE','avQIy0SMRn0','grRhpfQbBZI','c0I4ahyGIkA','6QQqqvq4R9A','Yy2cBOqUN_o','1be17hoGDvA','ajq5yXxtUf0','RO_54Ly2S5o','7nrsVjvALnA','B32-20i-7Wg','8wwwDJvehKk','kX9lb7LUDWc','olyR1TVhy04','GZwg03HNrno','5hvn-2WW6rY','sC5ekjSF21w','QxsFddFPIdg','lU9E1CGYVAg','BnYkT95oHHg','UG74NX7IQ8o','ibmJE1cbulk','MHZvk_XpK2I','UQ6cHjRjHSg','mZOnsxS9Cl0','jLib1vTxNLo','DdkpO-LphlU','vS7LVkPyXJU','foPemyxT1HU','0HFkStS9Gq0','AWeqehFLOgo','fuPcLioNlTk','npnyKVgd-Kk','gbEJm9q2Pkk','SDoMyyylpnc','Y_YSuBfQCmI','dqhRSGrFq-o','p5nDU-d3Y0s','e-qSSI1r7bA','w504XUUximQ','6r1nqDGdIRg','VeiHRfGxTzY','njDnOteVf6c','U66avewmxJk','rR3o58cEQhA','_zZrmWCGdsg','VAWqURK_Th0','4hhP-Ud4e84','PdDBTrkGYLo','pSLIG2E_gaw','rrv_r5GCCIw','Kfb21cW3lFk','Ar5FGfHXwMU','jWM64nraN_Y','FiTL2LuUcYY','NouUKDGyH5c','nhlahxZjsVM','eNWj6qSRDks','mW0xpDBDgLc','MpY1f9iPlNg','DW989jCuk34','yFfi42ltBQ4','-PR_BybYYqo','bx1G9db3FjA','-p-KCm6xB9I','IRkAbNRT_Yg','GFpxQ2ZyNc0','E4944K_4SvI','Z8Ybwv9_v8M','kkXDhAUnxYI','0GOUcmFYsZ4','-eDpBjt6UL0','SBGakFRJVDA','tPRwTxNAE9g','MaVfeFFXPsk','ZzpwBhVXVas','s8Rg2rBpm9Y','WaRAHxoBVIo','U6pLKRSQLis','_8rjlHwN4uk','ttWdHcG7D20','ivU6tleiHN4','v4WVTcFKIDM','BUdH3r6s0EM','URN8hRDvaCo','jh-URAueY6k','3Kv48NS4WUU','pjyovKCKhSA','DcitvRh5n18','HJpS_vj1VWo','Nhs0sLAn1Is','SBrmMHPRNGI','qPJ6eRAMmCM','-HPhkZcJQNk','L5toD-TrGj8','BuQ1RZckYW4','BvUHuUNyGDM','VbP9v1rh-sc','fwqXgxeKwKE','EOzeeoiHMIo','NeCNxRwobes','WeMl8eWMnjw','PbtAUw8Yjn8','innb1UEpVZg','NZP1fIhUOpo','Qn1bIlxiGKE','Un4xJv97V90','x6-a5IznCUY','5IDHgcr3Nvg','9i9RquPtXsg','Yui5vfKHuzs','jb1Mc1lv8X0','iuJZZqlbxks','pKNqyx_v62s','Wl-cl8xk7gg','ZuPa0DYH1IA','V97GBzRkqEg','lzfk5IMVpgo','szsMvHD45qU','jk7R3APcS64','cYzUuNv-zfI','NYDTneTcSdo','AeABkasP-24','vLPiJPBmqLc','RCQgNMq6hTA','yZygONrUBe8','XgIwVSXhHHw','1dHWJan7_rU','zt_obo4NQYo','GJogrGZxKJE','g4VeuOciK00','UfjN6fAJSUU','ppnnu5-9bgI','O7zkyNkQ1lM','9R9Z8PHwo2E','3x1STcytAVc','nWL0GBuJqcw','JQY8Z8OpEq4','zATDM3xbOBI','NmMUbokN4Jo','Z2w1a_7RWrE','zrfD9aVUVsU','h3GAGi5tXMU','hyJbDfTa-X8','ApJp5Nk24a0','ci_ZkHZpH64','-kT_jqkMmFc','Z5PIzFT_ZZU','bFbHAYJ5_go','CRM_V42L0bw','ETN1HRiZag8','gqOLnPTxRHc','SJz82JwseZQ','ZM7PgZ1zU2k','Usn68-mvjjo','RgTI2KaQ5N4','t8__xN-MdNI','vEPsR_iV31c','zoA8uW7jvP0','wdL8UywQtWU','xfR1xAE_How','2YA2PF8vvXU','jeC5QpsCKVc','vYsOa_s3C6g','6SbFGnQTE8s','IpuuBrEPUVE','duBfbutlbx0','YQD1Xljt4xo','EC4T7d3QnlQ','uxai8LrlJhw','ezJhm4xrHAM','PYp59F6KF4s','Qzs-8tgI2dk','c8N9zSbYjy4','6WUPDCnCMeg','5EB1k3iCsJM','UbVfb4fh1QE','EcVGogpC1G4','EsvpmQ4zp5Y','641pLhGEEyg','YfTd3yYySNY','a8YV2C3yBMk','raNGlrn5JRI','IagoFxKy6q0','V-j6C9UEGjs','76-58HpxvpQ','Hz8qhojEvnI','zgqUtdFezk4','lDXo_PA_8BU','QIJvMvO3KFU','DXhNKOe58mg','gKn1y-fW9ks','HGJqVcbQLgk','CZxxc6XlLOA','56iEnBJ_QGQ','UExx0KnnkjY','hj6Xydzu05c','yiUxeM2zVa8','VBNb52J8Trk','FOlRrcqLghA','fU9pbgetP1c','_DAY5kuDvsU','KvPgo1rcRkM','DKix6Un55mw','z_9VmsxR8hs','ZsA3DknVxRc','npZR4G67ev8','1Dod0VNRvCs','F1iDGmG9Kew','XGDBdSQ70O0','DcQ8dSqEosA','0yQPd95ScSc','-FmU063enhU','6te9SupeW1g','NkW53UJuCME','OitUG45b51Y','HyEtBCPlgmY','kNo6H-MDTzA','tOYIL_xDSZ0','4-40s-0mzYw','wUw76hSqbyc','D5OzyJ71mLI','CD1CT8nDkJk','BYu8ITUWMfc','va_nrBLonf8','X3tzSCwKcqI','oUMjZliHG2Y','TRtjX1XUyUg','u5K46PukKAo','spLDRvpViIM','2aTJfxUhL08','hFzIoD0F_i8','9teLSxO0-Ac','lKbW5QTT3nQ','gAaS2poXaU4','so4ElujJVP8','KhMOgu2olQ4','pJ3syPLST4k','VsekxX-4UbE','BzTtMU86BB4','i54owgDjXeY','UcFzZLmQcW0','DXQB5D1njMY','v9r31Dxg0X0','0o6nWyNV3jw','Q1p7bh3SHj8','DZcSURqSETc','owzg4RKSeE8','KDYcgCEoFcY','G82F03I5MOg','xKnXRV36fEY','bIEUEpNes1M','aJvSX36kweg','koy6FlCCy5s','hu2_cFFfVSA','IuILSdEn4IQ','Ec_WHv4aAno','-vWXlVr3n6g','45qGrlP-aBY','dQXXN0cvZnI','bvuwsIUCksA','1KzahFBUKJU','dLQcJmMLB0E','Qa2tSHWgh84','6AyyafVMJzQ','grCP1PYmw60','_IWp5j2CKdk','kiYzznir-uo','IUY_3DvM__w','E7q00J_8N7A','Fkc2KrT_5cA','k6RX6qJF-u8','5Gqx11weVJI','UqZvdVB1V4M','_SFJhRPzJHs','LtnPejWDSAY','gM6k0JmHIBE','6QG53_QOtqM','dgZbfQz3rA8','2kcqB9H1Xps','Dq5P6eWZXNY','ZB3OBIkNh6E','3aINMi09kX8','Qdi8UvGd1Ww','t-TaOF3zr1s','upAcOBgFDm0','YqPngNRUM_4','EKR5jJ2mON8','hfaLwsFOcwo','4AmyOdXZAQc','FauBUuNPq5k','i71W6sjKLAg','2ShvY8Lf6l0','Utsvwy1XAX4','4u_NwZCnwuY','je3_oa2pIwo','CNrqbVeQUzw','RZrIJ8C0860','5efxlA3fKtU','T_GMthbX72k','gmy25xvSkq8','uR5w1Y9-8yE','dKe9GgzS8Ek','P8PlK2nGwqA','sY5tcoweAz8','vIqxsp0_p1g','hdj_SUdczBI','GXEZuWo5m4I','kfxEUCTUeyg','tWWCqIMiUmg','Od7dXSSQMn0','SgyH_Ix9lNE','FFCgotROOTY','MH_psben7HE','tSc0IGImr-c','CgyrwbE6Hm4','NqeB4q6KOFg','wBEzT7u7knk','HF-buLPeNvg','fxrl9M_b9uo','0U_gjae2TKo','omborCwhDUs','hmyVTVUxQek','9MWUzbR_KwU']
const screenRes = window.screen.width
export default {
  components: {
    NewContentAvailableToastr,
    AppleAddToHomeScreenModal,
    LandingPage,
    LoadingView,
    DashboardView
  },
  props: {
    source: String
  },
  data: () => ({
    drawer: null,
    image: '',
    thumb: '',
    attrib: '',
    visible: true
  }),
  computed: {
    ...mapGetters('app', ['newContentAvailable']),
    ...mapState('app', ['showAddToHomeScreenModalForApple', 'refreshingApp']),
    ...mapGetters('authentication', ['isUserLoggedIn']),
    ...mapState('authentication', ['user']),
    ...mapState('dashboard', ['dashboard']),
    ...mapState('settings', ['settings']),
    ...mapState('app', ['networkOnLine', 'appTitle', 'appShortTitle'])
  },
  beforeMount() {
    this.checkCurrentDay()
  },
  methods: {
    ...mapActions('app', [
      'closeAddToHomeScreenModalForApple',
      'serviceWorkerSkipWaiting'
    ]),
    async logout() {
      await firebase.auth().signOut()
    },
    checkCurrentDay() {
      console.log('Settings are: ', this.settings)
      const today = new Date()
      const first = new Date(today.getFullYear(), 0, 1)
      const theDay = Math.round((today - first) / 1000 / 60 / 60 / 24 + 0.5, 0)
      const imgKey = localStorage.getItem('imgKey')
      if (imgKey !== null) {
        console.log('Image Key is not null')
        if (imgKey === imageList[theDay]) {
          this.thumb = localStorage.getItem('thumbimage')
          this.image = localStorage.getItem('bgimage')
          this.attrib = localStorage.getItem('attrib')
        } else {
          this.getTodaysImg(theDay)
        }
      } else {
        this.getTodaysImg(theDay)
      }
    },
    getTodaysImg(theDay) {
      console.log('The day of the image: ', theDay)
      unsplash.photos
        .getPhoto(imageList[theDay])
        .then(toJson)
        .then(json => {
          console.log('json: ', json)
          const attrib = `Photo by <a href="https://unsplash.com/@${json.user.username}?utm_source=saga_dashboard&utm_medium=referral" color="white">${json.user.name}</a><br />on <a href="https://unsplash.com/?utm_source=saga_dashboard&utm_medium=referral" color="white">Unsplash</a>`
          localStorage.setItem('attrib', attrib)
          localStorage.setItem('imgKey', json.id)
          this.setImage('thumbimage', json.urls.thumb)
          this.setImage('bgimage', `${json.urls.raw}&w=${screenRes}&dpr=1`)
          // this.setImage('bgimage', json.urls.full)
        })
        .catch(err => {
          console.log('There is an error: ', err)
        })
    },
    setImage(key, path) {
      const toDataURL = url =>
        fetch(url)
          .then(response => response.blob())
          .then(
            blob =>
              new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onloadend = () => resolve(reader.result)
                reader.onerror = reject
                reader.readAsDataURL(blob)
              })
          )
      toDataURL(path)
        .then(dataUrl => {
          localStorage.setItem(key, dataUrl)
          console.log('RESULT:', dataUrl)
        })
        .then(() => {
          this.thumb = localStorage.getItem('thumbimage')
          this.image = localStorage.getItem('bgimage')
          this.attrib = localStorage.getItem('attrib')
        })
    }
  }
}
</script>

<style lang="scss">
body {
  background-color: black;
  margin: 0;
  .theme--light {
    &.v-application {
      background-color: transparent;
    }
  }

  a {
    font-weight: 500;
    text-decoration: none;
  }

  .progressive-background-image {
    background-size: cover;
    background-position: center;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    color: #2c3e50;
    // background-image: url('https://images.unsplash.com/photo-1473654729523-203e25dfda10?auto=format&fit=crop&ixid=eyJhcHBfaWQiOjEyMDd9&ixlib=rb-1.2.1&q=80&w=2850) 50%');
    // background-image: url('https://images.unsplash.com/photo-1516395268396-710c728531c9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80');
    background-size: cover;
    background-position: center;
    padding: 0px;
    filter: none !important;

    .new-content-available-toastr {
      position: absolute;
      bottom: 10px;
      right: 10px;
    }

    .apple-add-to-home-screen-modal {
      position: absolute;
      bottom: 0;
      right: 0;
      top: 0;
      left: 0;
      height: fit-content;
      width: fit-content;
      margin: auto;
      z-index: 1000;
    }

    .main-wrapper {
      margin-top: 3.6rem;
      padding: 20px;

      .page-wrapper {
        width: 60%;
        margin: auto;

        @media screen and (max-width: 1000px) {
          width: 100%;
        }
      }
    }
    .offline-msg {
      color: #fff;
    }
  }
}
.fill-height {
  padding: 0px !important;
}
.whitewhite {
  color: white;
}
.full-height {
  height: 100%;
}
.row-section {
  &.row-odd {
    height: 33%;
    // border: 1px dashed rgba(255, 255, 255, 0.4);
    div.inner {
      display: inline-block;
      color: white;
    }
  }
  &.row-even {
    height: 34%;
    // border: 1px dashed white;
    div.inner {
      display: inline-block;
      color: white;
    }
  }
}
.centered-login {
  margin: 0 auto;
  text-align: center;
}

.widget-left {
  text-align: left;
}
.widget-center {
  text-align: center;
}
.widget-right {
  text-align: right;
}
#remove-pad {
  padding: 0px;
}
</style>
